import React from 'react';
import { WalletIcon, ArrowRightIcon, CoinsIcon, BarChart3Icon, PiggyBankIcon, CreditCardIcon, TrendingUpIcon, PercentIcon, BanknoteIcon, CalculatorIcon } from 'lucide-react';
export function HeroSection() {
  return <section className="bg-slate-900 text-white pt-14 pb-16 px-4 sm:px-6 lg:px-8 relative overflow-hidden" data-id="element-88">
      {/* Background glow */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full max-w-3xl h-48 bg-amber-500/10 blur-[100px] rounded-full pointer-events-none" data-id="element-89"></div>

      {/* Floating finance icons */}
      <div className="absolute inset-0 pointer-events-none overflow-hidden" data-id="element-90">
        <CoinsIcon className="absolute top-8 left-[8%] w-10 h-10 text-amber-500/[0.07] rotate-12" data-id="element-91" />
        <BarChart3Icon className="absolute top-16 right-[10%] w-14 h-14 text-amber-500/[0.06] -rotate-12" data-id="element-92" />
        <PiggyBankIcon className="absolute top-[40%] left-[5%] w-12 h-12 text-amber-500/[0.08] rotate-6" data-id="element-93" />
        <CreditCardIcon className="absolute top-[30%] right-[6%] w-10 h-10 text-amber-500/[0.07] -rotate-6" data-id="element-94" />
        <TrendingUpIcon className="absolute bottom-20 left-[12%] w-16 h-16 text-amber-500/[0.06] rotate-3" data-id="element-95" />
        <PercentIcon className="absolute bottom-16 right-[14%] w-8 h-8 text-amber-500/[0.09] -rotate-12" data-id="element-96" />
        <BanknoteIcon className="absolute top-12 left-[30%] w-9 h-9 text-amber-500/[0.05] rotate-45" data-id="element-97" />
        <CalculatorIcon className="absolute bottom-24 right-[30%] w-11 h-11 text-amber-500/[0.06] -rotate-6" data-id="element-98" />
        <CoinsIcon className="absolute top-[55%] right-[3%] w-8 h-8 text-amber-500/[0.07] rotate-45" data-id="element-99" />
        <BanknoteIcon className="absolute bottom-10 left-[3%] w-12 h-12 text-amber-500/[0.05] -rotate-12" data-id="element-100" />
        <CreditCardIcon className="absolute top-6 right-[35%] w-7 h-7 text-amber-500/[0.06] rotate-12" data-id="element-101" />
        <TrendingUpIcon className="absolute top-[45%] left-[25%] w-8 h-8 text-amber-500/[0.04] -rotate-3" data-id="element-102" />
      </div>

      <div className="max-w-3xl mx-auto text-center relative z-10" data-id="element-103">
        <div className="inline-flex items-center justify-center p-2.5 bg-slate-800 rounded-xl mb-5 border border-slate-700" data-id="element-104">
          <WalletIcon className="w-6 h-6 text-amber-500" data-id="element-105" />
        </div>

        <h1 className="text-3xl md:text-4xl lg:text-5xl font-extrabold tracking-tight mb-4 leading-tight" data-id="element-106">
          Recupera el control de tu sueldo{' '}
          <span className="text-amber-500" data-id="element-107">antes del día 15</span>
        </h1>

        <h2 className="text-lg md:text-xl text-slate-300 font-medium mb-8 max-w-2xl mx-auto leading-relaxed" data-id="element-108">
          El sistema de "Sobres Digitales" para ganarle a la inflación y dejar
          de preguntarte a dónde se fue tu dinero.
        </h2>

        <div className="bg-slate-800/50 border border-slate-700 rounded-lg px-4 py-3.5 text-left max-w-xl mx-auto backdrop-blur-sm mb-7" data-id="element-109">
          <p className="text-sm text-slate-400 mb-2 leading-relaxed" data-id="element-110">
            Son las 11 de la noche. Miras tu saldo y sientes ese frío en el
            estómago. Faltan 10 días para fin de mes y ya no queda casi nada.
          </p>
          <p className="text-sm text-slate-400 leading-relaxed" data-id="element-111">
            Trabajas duro, ganas "bien", pero el dinero se evapora. El saldo
            siempre llega a cero antes de tiempo. Esa ansiedad constante no es
            vida.
          </p>
        </div>

        <button onClick={() => document.getElementById('offer-section')?.scrollIntoView({
        behavior: 'smooth'
      })} className="inline-flex items-center justify-center px-7 py-3.5 text-base font-bold text-slate-900 bg-amber-500 hover:bg-amber-400 rounded-full transition-all duration-200 shadow-[0_0_20px_rgba(245,158,11,0.3)] hover:shadow-[0_0_30px_rgba(245,158,11,0.5)] hover:-translate-y-0.5" data-id="element-112">
          QUIERO RECUPERAR EL CONTROL
          <ArrowRightIcon className="ml-2 w-4 h-4" data-id="element-113" />
        </button>
        <p className="mt-3 text-xs text-slate-500" data-id="element-114">
          Acceso inmediato • Pago seguro
        </p>
      </div>
    </section>;
}